import type { IntlShape } from 'react-intl'

export const getManageDuoArgs = (intl: IntlShape) => {
  return [
    {
      label: intl.formatMessage({
        id: 'features.page.sectionManage.duo.arg1.label',
        defaultMessage: 'Doc verification',
      }),
      title: intl.formatMessage({
        id: 'features.page.sectionManage.duo.arg1.title',
        defaultMessage: 'Trust without second-guessing',
      }),
      description: intl.formatMessage({
        id: 'features.page.sectionManage.duo.arg1.description',
        defaultMessage:
          "Verify your docs so your team always knows what's relevant. They can trust what's on Slite and get on with their work, with all the info they need.",
      }),
      imageSrc:
        'https://cdn.sanity.io/images/dnsgqii5/production/b0cec34485d9d530bcc5fd278b5d52bbc0ca6ffb-2354x1200.png',
    },
    {
      label: intl.formatMessage({
        id: 'features.page.sectionManage.duo.arg2.label',
        defaultMessage: 'Analytics',
      }),
      title: intl.formatMessage({
        id: 'features.page.sectionManage.duo.arg2.title',
        defaultMessage: "Know who's in the loop",
      }),
      description: intl.formatMessage({
        id: 'features.page.sectionManage.duo.arg2.description',
        defaultMessage:
          'Keep track of what your team is reading and searching for, and easily make sure your latest docs get in front of the right people.',
      }),
      imageSrc:
        'https://cdn.sanity.io/images/dnsgqii5/production/363f118d77cb555c489e123b539a72b9e117aaba-2354x1200.png',
    },
  ]
}
